import axios from 'axios';

import { store } from '../../redux/store';

const apiGestao = axios.create({
  baseURL: process.env.REACT_APP_GESTAO_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});

const apiEditor = axios.create({
  baseURL: process.env.REACT_APP_EDITOR_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});

apiEditor.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const user = state.token.usuario;
    const accessToken = state.token.accessToken;
    const refreshToken = state.token.refreshToken;

    if (state.token) {
      config.headers.Authorization = `Bearer ${accessToken}`;
      config.headers.EmpresaContratanteID = user?.contratante.id;
      config.headers.Email = user?.email;
      config.headers.DataLogin = user?.dataLogin;
      config.headers.RefreshToken = refreshToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

apiEditor.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      window.location.href = !process.env.REACT_APP_ENV
        ? 'EditorSPED.App/error'
        : '/error';
    }

    if (error.response) {
      console.error('Erro de API:', error.response.status, error.response.data);
    } else {
      console.error('Erro geral:', error.message);
    }
    return Promise.reject(error);
  },
);

export { apiEditor, apiGestao };
